/* Brand index: live filter, letter jump, active letter while scrolling. */
(function () {
  'use strict';
  /* Secties nemen dit bestand elk zelf op, dus staat het soms twee of drie keer
     op één pagina. De browser voert elke tag dan opnieuw uit, waardoor listeners
     op document dubbel hangen en één klik twee acties uitvoert. Deze poort laat
     alleen de eerste uitvoering door. */
  window.__hwsLoaded = window.__hwsLoaded || {};
  if (window.__hwsLoaded['component_brand_index']) return;
  window.__hwsLoaded['component_brand_index'] = true;

  class HwsBrandIndex extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-brand-filter]');
      this.groups = Array.prototype.slice.call(this.querySelectorAll('[data-brand-group]'));
      this.items = Array.prototype.slice.call(this.querySelectorAll('[data-brand-item]'));
      this.empty = this.querySelector('[data-brand-empty]');
      this.letterButtons = Array.prototype.slice.call(this.querySelectorAll('[data-brand-letter]'));
      var self = this;
      if (this.input) this.input.addEventListener('input', function () { self.filter(); });
      this.letterButtons.forEach(function (button) {
        if (button.tagName !== 'BUTTON') return;
        button.addEventListener('click', function () {
          if (self.input) self.input.value = '';
          self.filter();
          self.setActiveLetter('');
        });
      });
      this.trackScroll();
      this.volgHeader();
    }

    /* De letterbalk plakt onder de header, en die verandert van hoogte: bovenaan
       163px, en zodra je scrolt klapt de zoekbalk weg en wordt hij 64px. De CSS
       rekende met een vaste --header-height, dus bleef de balk op 163px hangen en
       zag je de merken door het gat van 99px eronder langs schuiven.

       Hier meten we de onderkant van de header rechtstreeks op, vlak voor het
       tekenen. Dat kan niet achterlopen. */
    volgHeader() {
      var header = document.querySelector('[data-sticky-header]');
      if (!header) return;
      var self = this;
      var vorige = -1;
      var gepland = false;
      var zet = function () {
        var onder = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
        if (onder === vorige) return;
        vorige = onder;
        self.style.setProperty('--brand-header-offset', onder + 'px');
      };
      var plan = function () {
        if (gepland) return;
        gepland = true;
        requestAnimationFrame(function () { gepland = false; zet(); });
      };
      zet();
      window.addEventListener('scroll', plan, { passive: true });
      window.addEventListener('resize', plan, { passive: true });
      if (typeof ResizeObserver === 'function') {
        this.headerWaarnemer = new ResizeObserver(zet);
        this.headerWaarnemer.observe(header);
      }
    }

    filter() {
      var term = (this.input ? this.input.value : '').trim().toLowerCase();
      var visible = 0;
      this.items.forEach(function (item) {
        var show = !term || item.textContent.trim().toLowerCase().indexOf(term) !== -1;
        item.hidden = !show;
        if (show) visible++;
      });
      this.groups.forEach(function (group) {
        var any = Array.prototype.slice.call(group.querySelectorAll('[data-brand-item]')).some(function (i) {
          return !i.hidden;
        });
        group.hidden = !!term && !any;
      });
      if (this.empty) this.empty.hidden = visible !== 0;
    }

    setActiveLetter(letter) {
      this.letterButtons.forEach(function (el) {
        el.classList.toggle('is-active', (el.getAttribute('data-brand-letter') || '') === letter);
      });
    }

    trackScroll() {
      if (!('IntersectionObserver' in window)) return;
      var self = this;
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              self.setActiveLetter(entry.target.getAttribute('data-brand-group'));
            }
          });
        },
        { rootMargin: '-30% 0px -60% 0px' }
      );
      this.groups.forEach(function (group) { io.observe(group); });
    }
  }
  if (!customElements.get('hws-brand-index')) customElements.define('hws-brand-index', HwsBrandIndex);
})();
